module.exports = __webpack_public_path__ + "static/media/file.c7e305ac.svg";